var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"tick-a","d":"M8.375 15.619L18.66 5.264l1.376 1.376L8.375 18.3l-5.41-5.41 1.305-1.376z"})),React.createElement("use",{"fill":"currentColor","xlinkHref":"#tick-a","fillRule":"evenodd","transform":"translate(-3 -5)","key":1})]);
}

Tick.defaultProps = {"viewBox":"0 0 17 14","width":"17","height":"14"};

module.exports = Tick;

Tick.default = Tick;
